import type { Modifier } from '@popperjs/core';

/**
 * Модификатор для Popper.js, выставляющий ширину поповера в том же размере что и и референс
 */
export const sameWidth: Modifier<'sameWidth', void> = {
  name: 'sameWidth',
  enabled: true,
  phase: 'beforeWrite',
  requires: ['computeStyles'],
  fn: ({ state }) => {
    // eslint-disable-next-line no-param-reassign -- Мы не можем иначе выставить стили в DOM
    state.styles.popper.width = `${state.rects.reference.width}px`;
  },
  effect: ({ state }) => {
    // @ts-expect-error -- Оно на самом деле есть
    const { offsetWidth = 0 } = state.elements.reference;
    if (typeof offsetWidth !== 'number') return;
    // eslint-disable-next-line no-param-reassign -- Мы не можем иначе выставить стили в DOM
    state.elements.popper.style.width = `${offsetWidth}px`;
  },
};
